// extracted by mini-css-extract-plugin
export default {"account":"StellarPublicKey_account__tvOV3","identicon":"StellarPublicKey_identicon__aPY20"};